import React, { useState, useEffect, useMemo, Fragment } from "react";
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Button,
  Row,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
} from "reactstrap";
import { useForm } from "react-hook-form";
import DataTable from "react-data-table-component";
import DatePicker from "react-datepicker";
import { H3, Btn, Breadcrumbs, H4 } from "../../../AbstractElements";
import { Link, useNavigate } from "react-router-dom";
import {
  addSetupCost,
  getclientpackage,
  postShowTemp,
  postShowTrail,
} from "../../../CommonURL";
import {
  getDataWithToken,
  postDataWithToken,
  postMasterToken,
} from "../../../Utils/restUtils";
import { Add } from "../../../Constant";
import {
  TempDataColumns,
  // TraialDataColumns,
} from "../../../Data/MockTable/TempData";
import SearchList from "../../../CommonElements/Search";
import Transparentspinner from "../../Common/loader/Transparentspinner";
import { Typeahead } from "react-bootstrap-typeahead";
import { toast } from "react-toastify";
import IndustryFilter from "../../Common/Filters/IndustryFilter";
import CompanyFilter from "../../Common/Filters/CompanyFilter";
import { selectRoleId } from "../../../Redux/personalDetail";
import { useSelector } from "react-redux";

const TrialTable = () => {
  const style2 = { width: 60, fontSize: 13, padding: 3, marginRight: "10px" };
  const roleId = useSelector(selectRoleId);
  const [tempList, setTempList] = useState([]);
  const [tempDataValue, setTempDataValue] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [searchResetKey, setSearchResetKey] = useState(0);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [showPlanModal, setShowPlanModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [packageOptions, setPackageOptions] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [isIndustry, setIsIndustry] = useState("");
  const [appliedFilters, setAppliedFilters] = useState({});
  const [isCompany, setIsCompany] = useState("");
  const [dateRange, setDateRange] = useState([
    //   filters.start_date,
    //   filters.end_date,
  ]);
  const [startDate, endDate] = dateRange;
  const toggleStyle = {
    padding: "10px 20px",
    opacity: "0.8",
    fontSize: "14px",
  };
  const navigate = useNavigate();
  useEffect(() => {
    fetchUsers(1);
  }, []);
  const TraialDataColumns = (redirectTopackage) =>
    [
      {
        name: <H4>Sl No</H4>,
        cell: (row, index) => index + 1,
        sortable: true,
        width: "70px",
        center: true,
      },
      roleId === 1 && {
        name: <i className="fa fa-gears" style={{ fontSize: "15px" }}></i>,
        selector: (row) => row.action,
        cell: (row) => <ActionCell row={row} />,
        center: true,
        width: "55px",
      },
      {
        name: <H4>Name</H4>,
        selector: (row) => (
          <Link
            to={`${process.env.PUBLIC_URL}/subscriptions/company-list/userProfile?id=${row.user_id}`}
          >
            {row.user_name}
          </Link>
        ),
        sortable: true,
        width: "170px",
        wrap: true,
      },

      {
        name: <H4>Industry</H4>,
        selector: (row) => row.industry_name,
        sortable: true,
        width: "150px",
        wrap: true,
      },
      {
        name: <H4>Company Name</H4>,
        selector: (row) => (
          <Link
            to={`${process.env.PUBLIC_URL}/subscriptions/companyProfile?id=${row.company_id}&user_id=${row.user_id}&industryId=${row.industry_type_id}`}
            state={{
              clientUrl: row.client_url,
              industryName: row.Industry,
            }}
          >
            {row.company_name}
          </Link>
        ),
        sortable: true,
        width: "190px",
        wrap: true,
      },
      {
        name: <H4>Company Id</H4>,
        selector: (row) => (
          <Link
            to={`${process.env.PUBLIC_URL}/subscriptions/companyProfile?id=${row.company_id}&user_id=${row.user_id}&industryId=${row.industry_type_id}`}
            state={{
              clientUrl: row.client_url,
              industryName: row.Industry,
            }}
          >
            {" "}
            {row.company_id}
          </Link>
        ),
        sortable: true,
        width: "150px",
        wrap: true,
      },
      {
        name: <H4>Start Date</H4>,
        selector: (row) => row.start_date,
        sortable: true,
        width: "150px",
        wrap: true,
      },
      {
        name: <H4>End Date</H4>,
        selector: (row) => row.end_date,
        sortable: true,
        width: "150px",
        wrap: true,
      },
      {
        name: <H4>Phone No</H4>,
        selector: (row) => "+" + row.country_code + row.mobile,
        sortable: true,
        width: "170px",
        wrap: true,
      },
      {
        name: <H4>Email</H4>,
        selector: (row) => row.email,
        sortable: true,
        width: "230px",
        wrap: true,
      },
      {
        name: <H4>State</H4>,
        selector: (row) => row.state,
        sortable: true,
        width: "150px",
        wrap: true,
      },
      {
        name: <H4>Country</H4>,
        selector: (row) => row.country,
        sortable: true,
        width: "100px",
        wrap: true,
      },
    ].filter(Boolean);
  // const filteredItems = tempDataValue.filter(
  //   (item) =>
  //     (item.first_name &&
  //       item.first_name.toLowerCase().includes(searchKeyword.toLowerCase())) ||
  //     (item.industry_name &&
  //       item.industry_name
  //         .toLowerCase()
  //         .includes(searchKeyword.toLowerCase())) ||
  //     (item.last_name &&
  //       item.last_name.toLowerCase().includes(searchKeyword.toLowerCase())) ||
  //     (item.state &&
  //       item.state.toLowerCase().includes(searchKeyword.toLowerCase()))
  // );
  const handleConfirmPlan = async () => {
    if (!selectedPlan) {
      toast.error("Please select a subscription plan");
      return;
    }

    if (!selectedUser) {
      toast.error("User data missing");
      return;
    }

    const requestBody = {
      package_id: selectedPlan.value,
      company_id: selectedUser.company_id,
      user_id: selectedUser.user_id,
      created_admin: "1",
    };

    try {
      const response = await postDataWithToken(addSetupCost, requestBody);
      if (response?.data?.status === true) {
        if (response?.data?.data === "free") {
          navigate(`${process.env.PUBLIC_URL}/subscriptions/active-sub`);
        } else {
          navigate(
            `${process.env.PUBLIC_URL}/companies/company-list/userProfile/invoice?order_id=${response?.data?.data?.order_id}`,
          );
        }
      } else {
        toast.error("Try again");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    } finally {
      setShowPlanModal(false);
    }
  };

  const handleFilter = () => {
    const filters = {
      industry_id: isIndustry?.value || "",
      company_id: isCompany?.value || "",
      search: searchKeyword,
      start_date: startDate ? startDate.toISOString().split("T")[0] : "",
      end_date: endDate ? endDate.toISOString().split("T")[0] : "",
    };

    setAppliedFilters(filters);
    setCurrentPage(1);
    fetchUsers(1, perPage, filters);
  };

  const loadPackages = async (industryId, userId) => {
    try {
      const Postreq = {
        industry_type_id: industryId,
        user_id: userId,
      };
      const res = await postMasterToken(getclientpackage, Postreq);
      if (res?.data?.status === true) {
        const transformed = res.data.data.packages.map((pkg) => ({
          label: pkg.name,
          value: pkg.id,
          fullData: pkg,
        }));

        setPackageOptions(transformed);
      }
    } catch (err) {
      toast.error("Failed to load packages");
    }
  };
  const ResetFileter = () => {
    setIsCompany(null);
    setIsIndustry(null);
    setDateRange([null, null]);
    setSearchResetKey((prev) => prev + 1);
    setAppliedFilters({});
    setCurrentPage(1);
    fetchUsers(1, perPage, {});
  };
  const updateSearchKeyword = (keyword) => {
    setSearchKeyword(keyword);
  };
  const redirectTopackage = (row) => {
    setSelectedUser({
      user_id: row.user_id,
      company_id: row.company_id,
      industry_id: row.industry_type_id,
    });

    loadPackages(row.industry_type_id, row.user_id);
    setShowPlanModal(true);
  };

  const fetchUsers = async (page, size = perPage, filters = {}) => {
    setLoading(true);

    const {
      industry_id = "",
      company_id = "",
      search = "",
      start_date = "",
      end_date = "",
    } = filters;

    const response = await getDataWithToken(
      `${postShowTrail}?page=${page}&page_length=${size}&search=${search}&industry_type_id=${industry_id}&company_id=${company_id}&start_date=${start_date}&end_date=${end_date}`,
    );
    setTempDataValue(response?.data?.data);
    setTotalRows(response?.data?.total);
    setLoading(false);
  };

  const handlePageChange = (page) => {
    fetchUsers(page, perPage, appliedFilters);
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    fetchUsers(page, newPerPage, appliedFilters);
  };

  const handleCancel = () => {
    setShowPlanModal(false);
  };
  const ActionCell = ({ row }) => {
    const [dropdownOpen, setDropdownOpen] = React.useState(false);
    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    return (
      <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
        <DropdownToggle
          color="#00000"
          style={{ fontSize: "14px", zIndex: 1000 }}
        >
          <i className="fa fa-ellipsis-v"></i>
        </DropdownToggle>
        <DropdownMenu container="body">
          <DropdownItem
            style={toggleStyle}
            onClick={() => redirectTopackage(row)}
          >
            Renew
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  };

  return (
    <Fragment>
      {loading && <Transparentspinner />}
      <Breadcrumbs
        mainTitle="Trial Expired"
        parent="Trial Expired"
        title="Trial Expired"
      />
      <Card>
        <CardHeader>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <H3>Trial Expired List</H3>
          </div>
          <form
            className="px-4 pb-2"
            onSubmit={(e) => {
              e.preventDefault();
              handleFilter();
            }}
          >
            <Row className="g-3 align-items-center">
              <Col sm="12" md="5" lg="3" className="pt-3">
                <SearchList
                  key={searchResetKey}
                  className="form-control"
                  updateSearchKeyword={updateSearchKeyword}
                  onEnter={handleFilter}
                />
              </Col>
              <Col sm="12" md="6" lg="3">
                <DatePicker
                  className="form-control digits w-100"
                  selectsRange
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => {
                    setDateRange(update);
                  }}
                  isClearable={!!(startDate || endDate)}
                  monthsShown={2}
                  popperPlacement="bottom"
                  calendarClassName="parallel-calendar"
                  placeholderText="Select Date Range"
                  dateFormat="dd-MM-yyyy"
                />
              </Col>
              <Col sm="12" md="6" lg="3">
                <IndustryFilter
                  IsIndustry={isIndustry}
                  setIsIndustry={setIsIndustry}
                />
              </Col>
              <Col sm="12" md="6" lg="3">
                <CompanyFilter
                  IsCompany={isCompany}
                  setIsCompany={setIsCompany}
                  industryId={isIndustry?.value}
                />
              </Col>
              <Col sm="12" md="6" lg="3">
                <div style={{ display: "flex", gap: "10px" }}>
                  <button className="btn btn-primary" onClick={handleFilter}>
                    Filter
                  </button>

                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={ResetFileter}
                  >
                    Reset
                  </button>
                </div>
              </Col>
            </Row>
          </form>
        </CardHeader>
        <CardBody>
          <div className="order-history table-responsive">
            <DataTable
              columns={TraialDataColumns(redirectTopackage, roleId)}
              data={tempDataValue}
              pagination
              paginationServer
              defaultSortAsc
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              paginationRowsPerPageOptions={[10, 25, 50, 100]}
            />
          </div>
          <Modal isOpen={showPlanModal} centered backdrop="static">
            <ModalHeader>Choose Subscription Plan</ModalHeader>

            <ModalBody>
              <Label className="form-label">Subscription Plan</Label>
              <Input
                type="select"
                value={selectedPlan?.value ?? ""}
                onChange={(e) => {
                  const selected = packageOptions.find(
                    (item) => String(item.value) === e.target.value,
                  );
                  setSelectedPlan(selected || null);
                }}
              >
                <option value="">-- Select a package --</option>
                {packageOptions.map((pkg) => (
                  <option key={pkg.value} value={pkg.value}>
                    {pkg.label}
                  </option>
                ))}
              </Input>
            </ModalBody>

            <ModalFooter>
              <Button color="secondary" onClick={handleCancel}>
                Back
              </Button>

              <Button
                color="primary"
                onClick={handleConfirmPlan}
                disabled={!selectedPlan}
              >
                Continue
              </Button>
            </ModalFooter>
          </Modal>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default TrialTable;
